import React from "react";
import { Helmet } from "react-helmet";
import { SITE_URL } from "../../config";
export default function CircleHelmet({ circle }) {
  return (
    <Helmet>
      <meta charSet="utf-8" />
      <title>Ihopa - {circle.products[0].name}</title>
      <meta name="description" content={circle.description} />

      <meta property="og:title" content={"Ihopa - " + circle.products[0].name} />
      <meta property="og:url" content={SITE_URL + "/circle/" + circle.guid} />
      <meta property="og:site_name" content="Ihopa" />
      <meta property="og:image" content={circle.products[0].image_url} />
      <meta property="og:type" content="website" />
      <meta property="og:description" content={circle.description} />

      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={SITE_URL + "/circle/" + circle.guid} />
      <meta property="twitter:title" content={"Ihopa - " + circle.products[0].name} />
      <meta property="twitter:description" content={circle.description} />
      <meta property="twitter:image" content={circle.products[0].image_url} />
    </Helmet>
  );
}
